import type { RecommendedUsername } from './recommended-usernames.model';

export function transformRecommendedUsernames(
  username: string,
  extras: {
    readonly email?: string;
    readonly baseName?: string;
  },
): RecommendedUsername {
  return {
    id: `${extras.email}-${username}`,
    username,
    email: extras.email,
    baseName: extras.baseName,
  };
}
